/**
 * Quiet trust band that sits directly under the hero stage.
 * Hairline dividers, neutral typography, no icons, no chips.
 */
const HeroTrustBand = () => {
  const items = [
    { value: "500+", label: "Artisans" },
    { value: "50+", label: "Villages" },
    { value: "Free shipping", label: "Orders over ₹999" },
    { value: "Fair wages", label: "No middlemen" },
  ];

  return (
    <section
      aria-label="Gaonova at a glance"
      className="border-y border-border/60 bg-background"
    >
      <div className="container py-5">
        <ul className="grid grid-cols-2 md:grid-cols-4 divide-y md:divide-y-0 md:divide-x divide-border/60">
          {items.map((it) => (
            <li
              key={it.label}
              className="flex flex-col items-center justify-center text-center py-3 md:py-1 px-4"
            >
              <span className="text-sm md:text-[15px] font-medium text-foreground tracking-tight">
                {it.value}
              </span>
              <span className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground mt-0.5">
                {it.label}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default HeroTrustBand;
